import { LitElement, html, css, unsafeCSS } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { RDPropsetContainer } from '../Container/PropContainer.js';
import { animate } from 'motion';

import styles from './Alert.css?raw';

export class propAlert extends RDPropsetContainer {
  static styles = [
    super.styles,
    css`
      ${unsafeCSS(styles)}
    `,
  ];
  static properties = {
    value: { type: String },
    variant: { type: String, reflect: true },
    outline: { type: Boolean, reflect: true },
    radius: { type: String, reflect: true },
    disabled: { type: Boolean, reflect: true },
    closable: { type: Boolean, reflect: true },
    onClose: { type: Function },
  };
  constructor() {
    super();
    this.disabled = false;
    this.variant = 'primary';
    this.radius = '6px';
    this.closable = true;
    this.onClose = null;
    this.isDevices = false;
    this.isThemes = false;
    this.size = 'full';
  }
  firstUpdated() {
    this.size = 'full';
    this.isDevices = false;
    this.isThemes = false;
    super.firstUpdated();
  }
  // shouldUpdate(changedProperties) {
  //   if (changedProperties.has('size')) {
  //     return false;
  //   }
  //   if (changedProperties.has('isDevices') || changedProperties.has('isThemes')) {
  //     return false;
  //   }
  //   super.shouldUpdate(changedProperties);
  //   return true;
  // }

  handleClose(e) {
    e.stopPropagation();
    if (this.onClose) {
      this.onClose.bind(this)();
    }
    this._hide(true);
  }
  _createAlertValue() {
    let al = this.querySelector('.rd-prop-alert-message');
    if (al) {
      if (this.value === al.innerHTML) {
        return '';
      }
      al.innerHTML = this.value;
      return '';
    }
    al = document.createElement('div');
    al.slot = 'message';
    al.style.cssText = ' display: block; font-size: 14px; line-height: 1.5; white-space: normal;';
    al.classList.add('rd-prop-alert-message');
    this.appendChild(al);

    al.innerHTML = this.value;
    return '';
  }

  renderBody() {
    return html`
      <div class="rd-prop-alert-container" tabindex="-1">
        <div class="rd-prop-alert rd-prop-alert-${this.variant} ${this.outline ? 'rd-prop-alert-outline' : ''}" style="--rd-alert-radius: ${this.radius};" ?data-closable="${this.closable}">
          ${this.closable ? html`<span class="rd-prop-alert-close" @click="${this.handleClose}">×</span>` : ''}
          <slot name="message"></slot>
          ${this._createAlertValue()}
        </div>
      </div>
    `;
  }
}
if (!customElements.get('rd-prop-alert')) {
  customElements.define('rd-prop-alert', propAlert);
}
